import { Col, Row, Typography } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import ActionLogDrawerAsync from "@/v1/components/common/ActionLogDrawerAsync";
import { ConnectionsOverview } from "./components/ConnectionsOverview";
import { queryClient } from "./client";
import { IUser } from "@/v1/types";
import {
  SectionHeaderTbody,
  SectionHeaderTd,
  ViewLogsButton,
} from "../components/styles";

const getTexts = (t: TFunction) => ({
  title: t("title"),
  actionLogDrawer: {
    title: t("actionLogDrawer.title"),
    viewAuditLogs: t("actionLogDrawer.viewAuditLogs"),
  },
});

export const AccountingConnections = ({
  user,
}: {
  user: IUser | undefined;
}) => {
  const { t } = useTranslation("Documents");
  const texts = getTexts(t);

  if (!user) {
    return null;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <SectionHeaderTbody>
        <tr>
          <SectionHeaderTd colSpan={7}>
            <Row align="middle" justify="space-between">
              <Typography.Title level={3} style={{ margin: 0 }}>
                {texts.title}
              </Typography.Title>
              <Row align="middle" gutter={12} justify="end">
                <Col>
                  <ActionLogDrawerAsync
                    title={texts.actionLogDrawer.title}
                    modelName="documents_connection"
                    recordIds={[user.publicId]}
                    renderButton={({ onClick }) => (
                      <ViewLogsButton type="link" onClick={onClick}>
                        {texts.actionLogDrawer.viewAuditLogs}
                      </ViewLogsButton>
                    )}
                  />
                </Col>
              </Row>
            </Row>
          </SectionHeaderTd>
        </tr>
      </SectionHeaderTbody>
      <ConnectionsOverview customerId={user.publicId} />
    </QueryClientProvider>
  );
};
